import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
/* import navConfig from '../../config/navConfig' */
import style from './Footer.module.scss'

import Logo from '../logo/Logo'
import FooterNav from '../nav/FooterNav'

/*import srcLogoImg from '../../../static/assets/images/logos/sklogo_ru_optimized.png'*/

class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: props.intl.messages.footer,
      nav: props.intl.messages.nav,
      vacanciesLink: props.intl.messages.vacanciesLink,
    }
  }

  static propTypes = {
    intl: PropTypes.object,
  }

  render() {
    const { nav, data, vacanciesLink } = this.state
    const skLogo = require(`../../../static/assets/images/logos/sk-${this.props.intl.locale}.png`)
    const fasieLogo = require(`../../../static/assets/images/logos/fasie-${this.props.intl.locale}.png`)
    return (
      <footer className={style.footerContainer}>
        <div className={style.footerNav}>
          <Logo className={style.logoFooter} />
          <div className={style.footerLinks}>
            <FooterNav menuNav={nav} vacanciesLink={vacanciesLink} />
          </div>
          <div className={style.footerContacts}>
            <h3 className={style.contactsLabel}>{data.heading}</h3>
            <h3 className={style.contactsTel}>
              <a href={`tel:${data.telLink}`}>{data.tel}</a>
            </h3>
            <h3 className={style.contactsAdr}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://yandex.ru/maps/213/moscow/?ll=37.443349%2C55.709553&mode=usermaps&source=constructorStatic&um=constructor%3AAI__fX87ZIMEBxORsU402SMOYjbdkYYI&z=16"
              >
                {data.address}
              </a>
            </h3>
            <h3 className={style.contactsMail}>
              <a href={`mailto:${data.email}`}>{data.email}</a>
            </h3>
            <div className={style.socialContainer}>
              <a target="_blank" rel="noopener noreferrer" href="https://vk.com/ashmanov_net">
                <FontAwesomeIcon size="2x" icon={['fab', 'vk']} mask={['fas', 'circle']} transform="shrink-6" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/ashmanovnet">
                <FontAwesomeIcon size="2x" icon={['fab', 'facebook-f']} mask={['fas', 'circle']} transform="shrink-6" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://m.me/ashmanovnet">
                <FontAwesomeIcon size="2x" icon={['fab', 'facebook-messenger']} />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://telegram.me/ashmanov">
                <FontAwesomeIcon size="2x" icon={['fab', 'telegram']} />
              </a>
            </div>
          </div>
        </div>
        <div className={style.footerCopyright}>
          <div className={style.footerDivider} />
          <div className={style.copyrightInner}>
            <p className={style.copyrightText}>
              {/* <FontAwesomeIcon size="sm" icon={['far', 'copyright']} transform="shrink-3" /> */}
              <span>{`${data.copyright} – ${new Date().getFullYear()}`}</span>
            </p>
            <div className={style.copyrightInfo}>
              Исследования осуществляются ООО "Нейросети Ашманова" при грантовой поддержке Фонда Сколково
            </div>
            <div className={style.copyrightPartners}>
              <a href="https://sk.ru/" rel="noopener noreferrer" target="_blank">
                <img src={skLogo} alt="Skolkovo" />
              </a>
              <a href="http://fasie.ru/" rel="noopener noreferrer" target="_blank">
                <img src={fasieLogo} alt="FASIE" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default injectIntl(Footer)
